<div class="layout-wrapper">
  <app-sidenavigation [hideNavigation]="nativeShell || hideNavigation">
    <router-outlet></router-outlet>
  </app-sidenavigation>
</div>

<!-- Global Full-Page Loader Overlay using Taiga UI Loader -->
<div class="parking-change-loader" *ngIf="shouldShowLoader()">
  <div class="loader-content">
    <tui-loader [showLoader]="true" size="xl" class="taiga-spinner"></tui-loader>
    <div style="margin-top: 1.5rem; text-align: center;">
      <p class="loading-text">{{ loadingText }}</p>
    </div>
  </div>
</div>
